// extracted by mini-css-extract-plugin
module.exports = {"container":"Offers_container__HsrEU","col":"Offers_col__FCrql","heading":"Offers_heading__2Ptcp","details":"Offers_details__1wLp4"};